
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/work/generated/ui/shared/external-tools/jst/_external_tools_menu.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/features/wiki-page-index/jst/WikiPageIndex';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n<div class=\"header-bar-outer-container\">\n  <div class=\"sticky-toolbar-with-right-side\" data-sticky>\n    <div class=\"header-bar\">\n      <div class=\"header-bar-right\">\n        <div>\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.DELETE), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.CREATE), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </div>\n\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.CREATE), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n  </div>\n</div>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <button class=\"btn delete_pages\" tabindex=\"0\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "delete_selected_pages_7bc50580", "Delete selected pages", options) : helperMissing.call(depth0, "t", "delete_selected_pages_7bc50580", "Delete selected pages", options)))
    + "\" disabled>\n              <i class=\"icon-trash\" role=\"presentation\"></i>\n            </button>\n          ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <a class=\"btn btn-primary icon-plus new_page\" role=\"button\" tabindex=\"0\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.buttons.new_page_label", "Add a page", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.buttons.new_page_label", "Add a page", options)))
    + "\">\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.block_editor_is_preferred), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.no_preferred_editor), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.rce_is_preferred), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </a>\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasWikiIndexPlacements), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.buttons.new_page", "Page", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.buttons.new_page", "Page", options)))
    + " ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.buttons.new_rce_page", "RCE Page", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.buttons.new_rce_page", "RCE Page", options)))
    + " ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <div class=\"inline-block\">\n                  <a class=\"al-trigger btn\" role=\"button\" aria-haspopup=\"true\" aria-owns=\"toolbar-1\" href=\"#\">\n                    <i class=\"icon-more\" aria-hidden=\"true\"></i>\n                    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "pages_settings_968392a3", "Pages Settings", options) : helperMissing.call(depth0, "t", "pages_settings_968392a3", "Pages Settings", options)))
    + "</span>\n                  </a>\n                  <ul id=\"toolbar-1\" class=\"al-options\" role=\"menu\" aria-hidden=\"true\" aria-expanded=\"false\">\n                    ";
  stack1 = self.invokePartial(partials['ui/shared/external-tools/jst/_external_tools_menu.handlebars'], 'ui/shared/external-tools/jst/_external_tools_menu.handlebars', (depth0 && depth0.wikiIndexPlacements), helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  </ul>\n                </div>\n              ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          <div style=\"margin-top: 15px; text-align: right;\">\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.block_editor_is_preferred), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.rce_is_preferred), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </div>\n        ";
  return buffer;
  }
function program12(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <a href=\"#\" class=\"new_rce_page\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.buttons.use_the_rce", "Use the RCE", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.buttons.use_the_rce", "Use the RCE", options)))
    + "\n            </a>\n            ";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <a href=\"#\" class=\"new_block_editor_page\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.buttons.try_the_block_editor", "Try the Block Editor", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.buttons.try_the_block_editor", "Try the Block Editor", options)))
    + "\n            </a>\n            ";
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.noop,fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program17(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <div class=\"pages-mobile-header\" aria-hidden=\"true\">\n          <div class=\"pages-mobile-header-left\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "pages_e5414c2c", "Pages", options) : helperMissing.call(depth0, "t", "pages_e5414c2c", "Pages", options)))
    + "\n          </div>\n          <a class=\"al-trigger al-trigger-gray pages-mobile-header-right\" href=\"#\" role=\"button\" data-popup-within=\"#application\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "sort_by_e75f9e3e", "Sort By", options) : helperMissing.call(depth0, "t", "sort_by_e75f9e3e", "Sort By", options)))
    + "\n            <i class=\"icon-mini-arrow-down\" aria-hidden=\"true\"></i>\n          </a>\n          <ul class=\"al-options\">\n            <li><a href=\"#\" data-sort-mobile-field=\"title\" data-sort-mobile-key=\"asc\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "page_title_ascending_b5df950c", "Page title: Ascending", options) : helperMissing.call(depth0, "t", "page_title_ascending_b5df950c", "Page title: Ascending", options)))
    + "\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "page_title_ascending_b5df950c", "Page title: Ascending", options) : helperMissing.call(depth0, "t", "page_title_ascending_b5df950c", "Page title: Ascending", options)))
    + "\n            </a></li>\n            <li><a href=\"#\" data-sort-mobile-field=\"title\" data-sort-mobile-key=\"desc\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "page_title_descending_70c1483d", "Page title: Descending", options) : helperMissing.call(depth0, "t", "page_title_descending_70c1483d", "Page title: Descending", options)))
    + "\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "page_title_descending_70c1483d", "Page title: Descending", options) : helperMissing.call(depth0, "t", "page_title_descending_70c1483d", "Page title: Descending", options)))
    + "\n            </a></li>\n            <li><a href=\"#\" data-sort-mobile-field=\"created_at\" data-sort-mobile-key=\"asc\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "created_ascending_cff48774", "Created: Ascending", options) : helperMissing.call(depth0, "t", "created_ascending_cff48774", "Created: Ascending", options)))
    + "\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "created_ascending_cff48774", "Created: Ascending", options) : helperMissing.call(depth0, "t", "created_ascending_cff48774", "Created: Ascending", options)))
    + "\n            </a></li>\n            <li><a href=\"#\" data-sort-mobile-field=\"created_at\" data-sort-mobile-key=\"desc\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "created_descending_e9a1b097", "Created: Descending", options) : helperMissing.call(depth0, "t", "created_descending_e9a1b097", "Created: Descending", options)))
    + "\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "created_descending_e9a1b097", "Created: Descending", options) : helperMissing.call(depth0, "t", "created_descending_e9a1b097", "Created: Descending", options)))
    + "\n            </a></li>\n            <li><a href=\"#\" data-sort-mobile-field=\"updated_at\" data-sort-mobile-key=\"asc\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "last_edit_ascending_6a18dba4", "Last Edit: Ascending", options) : helperMissing.call(depth0, "t", "last_edit_ascending_6a18dba4", "Last Edit: Ascending", options)))
    + "\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "last_edit_ascending_6a18dba4", "Last Edit: Ascending", options) : helperMissing.call(depth0, "t", "last_edit_ascending_6a18dba4", "Last Edit: Ascending", options)))
    + "\n            </a></li>\n            <li><a href=\"#\" data-sort-mobile-field=\"updated_at\" data-sort-mobile-key=\"desc\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "last_edit_descending_6b7ee755", "Last Edit: Descending", options) : helperMissing.call(depth0, "t", "last_edit_descending_6b7ee755", "Last Edit: Descending", options)))
    + "\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "last_edit_descending_6b7ee755", "Last Edit: Descending", options) : helperMissing.call(depth0, "t", "last_edit_descending_6b7ee755", "Last Edit: Descending", options)))
    + "\n            </a></li>\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.collectionHasTodoDate), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </ul>\n        </div>\n        <table class=\"ic-Table ic-Table--condensed ic-Table--striped ic-Table--hover-row wiki-page-table\" role=\"grid\">\n          <thead>\n            <tr class=\"header-row\" role=\"row\">\n              ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.DELETE), {hash:{},inverse:self.noop,fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.block_editor), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              <th scope=\"col\" width=\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.MANAGE), {hash:{},inverse:self.program(29, program29, data),fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" role=\"columnheader\">\n                <span class=\"mobile-screenreader-only\">\n                  <a href=\"#\" data-sort-field=\"title\" tabindex=\"0\" role=\"button\" class=\"sort-field\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.headers.page_title", "Page title", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.headers.page_title", "Page title", options)))
    + " <i></i></a>\n                </span>\n              </th>\n              <th scope=\"col\"  style=\"width: 20%\" role=\"columnheader\">\n                <span class=\"mobile-screenreader-only\">\n                  <a href=\"#\" data-sort-field=\"created_at\" tabindex=\"0\" role=\"button\" class=\"sort-field\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.headers.creation_date", "Creation date", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.headers.creation_date", "Creation date", options)))
    + " <i></i></a>\n                </span>\n              </th>\n              <th scope=\"col\" style=\"width: 20%\" role=\"columnheader\">\n                <span class=\"mobile-screenreader-only\">\n                  <a href=\"#\" data-sort-field=\"updated_at\" tabindex=\"0\" role=\"button\" class=\"sort-field\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.headers.last_edit", "Last edit", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.headers.last_edit", "Last edit", options)))
    + " <i></i></a>\n                </span>\n              </th>\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.collectionHasTodoDate), {hash:{},inverse:self.noop,fn:self.program(31, program31, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.OPEN_MANAGE_OPTIONS), {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </tr>\n          </thead>\n          <tbody class=\"collectionViewItems\"></tbody>\n        </table>\n      ";
  return buffer;
  }
function program18(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n              <li><a href=\"#\" data-sort-mobile-field=\"todo_date\" data-sort-mobile-key=\"asc\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "to_do_date_ascending_c3a59abb", "To-Do Date: Ascending", options) : helperMissing.call(depth0, "t", "to_do_date_ascending_c3a59abb", "To-Do Date: Ascending", options)))
    + "\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "to_do_date_ascending_c3a59abb", "To-Do Date: Ascending", options) : helperMissing.call(depth0, "t", "to_do_date_ascending_c3a59abb", "To-Do Date: Ascending", options)))
    + "\n              </a></li>\n              <li><a href=\"#\" data-sort-mobile-field=\"todo_date\" data-sort-mobile-key=\"desc\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "to_do_date_descending_25b2141d", "To-Do Date: Descending", options) : helperMissing.call(depth0, "t", "to_do_date_descending_25b2141d", "To-Do Date: Descending", options)))
    + "\">\n                "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "to_do_date_descending_25b2141d", "To-Do Date: Descending", options) : helperMissing.call(depth0, "t", "to_do_date_descending_25b2141d", "To-Do Date: Descending", options)))
    + "\n              </a></li>\n            ";
  return buffer;
  }

function program20(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                <th width=\"2%\" role=\"columnheader\">\n                  <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "select_page_e93fc123", "Select page", options) : helperMissing.call(depth0, "t", "select_page_e93fc123", "Select page", options)))
    + "</span>\n                </th>\n              ";
  return buffer;
  }

function program22(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                <th scope=\"col\" width=\"24px\" role=\"columnheader\">\n                  <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "page_type_d1e0fec7", "page type", options) : helperMissing.call(depth0, "t", "page_type_d1e0fec7", "page type", options)))
    + "</span>\n                </th>\n              ";
  return buffer;
  }

function program24(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.PUBLISH), {hash:{},inverse:self.program(27, program27, data),fn:self.program(25, program25, data),data:data});
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }
function program25(depth0,data) {
  
  
  return "42%";
  }

function program27(depth0,data) {
  
  
  return "46%";
  }

function program29(depth0,data) {
  
  
  return "60%";
  }

function program31(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                <th scope=\"col\" style=\"width: 20%\" role=\"columnheader\">\n                  <span class=\"mobile-screenreader-only\">\n                    <a href=\"#\" data-sort-field=\"todo_date\" tabindex=\"0\" role=\"button\" class=\"sort-field\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.headers.todo_date", "To-Do Date", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.headers.todo_date", "To-Do Date", options)))
    + " <i></i></a>\n                  </span>\n                </th>\n              ";
  return buffer;
  }

function program33(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <th scope=\"col\" style=\"width: 5%\" role=\"columnheader\">\n                  <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "master_lock_590266b6", "Master Lock", options) : helperMissing.call(depth0, "t", "master_lock_590266b6", "Master Lock", options)))
    + "</span>\n                </th>\n                ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.PUBLISH), {hash:{},inverse:self.noop,fn:self.program(34, program34, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                <th scope=\"col\" style=\"width: 5%\" role=\"columnheader\">\n                  <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "manage_b88f7150", "Manage", options) : helperMissing.call(depth0, "t", "manage_b88f7150", "Manage", options)))
    + "</span>\n                </th>\n              ";
  return buffer;
  }
function program34(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                  <th scope=\"col\" style=\"width: 5%\" role=\"columnheader\">\n                    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "publish_5211dca3", "Publish", options) : helperMissing.call(depth0, "t", "publish_5211dca3", "Publish", options)))
    + "</span>\n                  </th>\n                ";
  return buffer;
  }

function program36(depth0,data) {
  
  
  return "loading";
  }

function program38(depth0,data) {
  
  
  return "loading-more";
  }

function program40(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.loading", "Loading ...", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.loading", "Loading ...", options)));
  }

function program42(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.loading_more", "Loading more ...", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.loading_more", "Loading more ...", options)));
  }

function program44(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.noop,fn:self.program(45, program45, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program45(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <div style=\"text-align: center\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.no_pages", "No pages created yet.", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.no_pages", "No pages created yet.", options)));
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.CREATE), {hash:{},inverse:self.noop,fn:self.program(46, program46, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</div>\n      ";
  return buffer;
  }
function program46(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += " <a class=\"new_page\" href=\"#\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.add_page", "Add one!", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.add_page", "Add one!", options)))
    + "</a>";
  return buffer;
  }

  buffer += "<h1 class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index.pages_title", "Pages", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index.pages_title", "Pages", options)))
    + "</h1>\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.VIEW_TOOLBAR), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n<div id=\"external-tool-mount-point\"></div>\n<div id=\"copy-to-mount-point\"></div>\n<div id=\"send-to-mount-point\"></div>\n<div id=\"assign-to-mount-point\"></div>\n<div class=\"index-content-container\">\n  <div class=\"index-content\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.fetched), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <div class=\"paginatedLoadingIndicator ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.fetched), {hash:{},inverse:self.program(38, program38, data),fn:self.program(36, program36, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" style=\"background-image: none;\">\n        ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.fetched), {hash:{},inverse:self.program(42, program42, data),fn:self.program(40, program40, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.fetched), {hash:{},inverse:self.noop,fn:self.program(44, program44, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n  <div id=\"choose-editor-mount-point\"></div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  